module.exports = __webpack_public_path__ + "b8a9e3c4145a17ef74bba20522889a7a.svg";


//////////////////
// WEBPACK FOOTER
// ./images/unarchive-icon-white.svg
// module id = 74
// module chunks = 0